import { FETCH_COURSES, FETCH_COURSES_SUCCESS, FETCH_COURSES_FAILURE, SAVE_COURSES_SUCCESS,
  SAVE_COURSES_FAILURE, DELETE_COURSES_SUCCESS, DELETE_COURSES_FAILURE, COURSES_AJAX_CALL,
  COURSES_CLEAR_AJAX_CALL } from '../actions/Courses'

const initialState = {
  list: null,
  error: null,
  loading: false,
  ajaxSpinner: false,
  ajaxStatus: null
}

export default function courses (state = initialState, action) {
  switch (action.type) {
    case FETCH_COURSES:
      return {...state, loading: true, error: null, list: null}
    case FETCH_COURSES_SUCCESS:
      return {...state, list: action.payload, loading: false, error: null}
    case FETCH_COURSES_FAILURE:
      return {...state, error: action.payload, loading: false, list: null}
    case SAVE_COURSES_SUCCESS:
      return {...state,
        list: ((state.list.findIndex(x => x.id === action.payload.id) === -1)
          ? state.list.concat(action.payload)
          : state.list.map((item) => {
            return (item.id === action.payload.id) ? action.payload : item
          })),
        ajaxStatus: null,
        ajaxSpinner: false}
    case SAVE_COURSES_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case DELETE_COURSES_SUCCESS:
      return {...state,
        list: state.list.filter((item) => {
          return item.id !== action.payload
        }),
        ajaxStatus: null,
        ajaxSpinner: false}
    case DELETE_COURSES_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case COURSES_AJAX_CALL:
      return { ...state, ajaxSpinner: true, ajaxStatus: null }
    case COURSES_CLEAR_AJAX_CALL:
      return { ...state, ajaxSpinner: false, ajaxStatus: null }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/courses.js